import React from 'react';
import type { EntryPointProps } from 'react-relay';
import type { RootUiModificationsQueryType } from '@atlassian/ui-modifications-core/gql';
import type { UiModificationsRootProps } from '@atlassian/ui-modifications-core/types';
import { UiModificationsRoot } from '@atlassian/ui-modifications-core';

export type RootEntrypointWrapperRuntimeProps = Omit<UiModificationsRootProps, 'queryReference'>;

type RootEntrypointWrapperProps = EntryPointProps<
	{ rootUiModificationsQuery: RootUiModificationsQueryType },
	{},
	RootEntrypointWrapperRuntimeProps,
	{}
>;

/**
 * The goal of this component is to wrap the UiModificationsRoot component with the queryReference prop
 * that is passed from the entrypoint in different shape that the
 * UiModificationsRoot (@atlassian/ui-modifications-core) component expects.
 *
 * @note UiModificationsRoot should not be adjusted to entrypoint's needs, as it is a shared component.
 */
export const RootEntrypointWrapper = ({
	props,
	queries: { rootUiModificationsQuery },
}: RootEntrypointWrapperProps): React.JSX.Element => {
	return <UiModificationsRoot {...props} queryReference={rootUiModificationsQuery} />;
};
